module.exports = __webpack_public_path__ + "img/module7.023c03a9.png";